import { Component, EventEmitter, Input, Output } from '@angular/core';

/** Add-client drawer for leads: contact details are optional. Same outputs as `app-add-edit-client-popup`. */
@Component({
  selector: 'app-add-edit-client-popup-for-lead',
  templateUrl: './add-edit-client-popup-for-lead.component.html',
})
export class AddEditClientPopupForLeadComponent {
  @Input() basicShow = false;
  @Input() defaultCompanyId: string | null = null;
  @Input() initialName = '';
  @Output() addClientPopupOnChange = new EventEmitter<{ name: string; value: any }>();

  onSaved(client: any): void {
    this.addClientPopupOnChange.emit({ name: 'resp', value: client });
  }

  close(): void {
    this.basicShow = false;
    this.addClientPopupOnChange.emit({ name: 'isVisible', value: false });
  }
}
